import axios from 'axios';
import { useAuthStore } from '@/stores/AuthStore.js';

// point to API endpoint
let neonSSOAPI = axios.create({
  baseURL: import.meta.env.VITE_NEON_SSO_API,
});

// // Add JWT to Headers
// api.defaults.headers.Authorization = localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : "";

export const onFullfilled = (response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  return response;
};
export const onRejected = async (error) => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  if (error.response?.status === 401) {
    useAuthStore().redirectToTokenAuth((path) =>
      window.location.hostname == 'localhost' ? (window.location.href = path) : null,
    );
    return Promise.reject(error);
  }
  return Promise.reject(error);
};

// // Add a response interceptor
neonSSOAPI.interceptors.response.use(onFullfilled, onRejected);

export default neonSSOAPI;
